module.exports = __webpack_public_path__ + "static/media/products-empty.3f67be2f.svg";